export default class Word {
    constructor(word) {
        this.word = word.toUpperCase();
        this.length = word.length;
        let o = {};
        for (let letter of this.word) {
            if (!(letter in o)) {
                o[letter] = 1;
            }
            else {
                o[letter]++;
            }
        }
        this.lettersObject = o;
        let r = [], s = [], d = [], t = [];
        let consonantCount = 0, vowelCount = 0;
        let c = [], v = [];
        for (let letter in o) {
            if (o[letter] == 1) {
                s.push(letter);
            }
            else {
                r.push(letter);
                if (o[letter] == 2) {
                    d.push(letter);
                }
                else if (o[letter] == 3) {
                    t.push(letter);
                }
            }
            if (letter == "A" || letter == "E" || letter == "I" || letter == "O" || letter == "U") {
                vowelCount += o[letter];
                v.push(letter);
            }
            else {
                consonantCount += o[letter];
                c.push(letter);
            }
        }
        if (Math.abs(vowelCount - consonantCount) < 2) {
            this.vowelConsonantDiff = Math.abs(vowelCount - consonantCount);
        }
        else {
            this.vowelConsonantDiff = 2;
        }
        this.repeats = r;
        this.singles = s;
        this.doubles = d;
        this.triples = t;
        this.consonants = c;
        this.vowels = v;
        this.vowelLength = vowelCount;
    }
}
